<template>
    <div class="btn-calculation position-absolute bottom-0 end-0 m-5 border border-primary" @click="onClick">
        <i class="bi bi-currency-pound currencySymbol"></i>
        <i class="bi bi-gear-fill text-primary cog"></i>
        <span class="visually-hidden">Show calculation details</span>
    </div>
</template>

<script setup lang="ts">

const emit = defineEmits<{ (e: 'showCalcs'): void }>();

function onClick() {
    emit('showCalcs');
}
</script>

<style scoped>
    .btn-calculation {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background-color: rgb(233, 242, 251);
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgb(113, 104, 104);
        cursor: pointer;
    }

    .btn-calculation:hover {
        background-color: white;
    }

    .currencySymbol {
        font-size: 1.1rem;
        position: absolute;
        left: -0.015rem;
        top: -0.1rem;
        color: rgb(66 79 79 / 99%);
        z-index: 2;
    }

    .cog {
        font-size: 0.73rem;
        position: absolute;
        left: 0.55rem;
        top: 0.35rem;
        color: rgb(83 173 17 / 88%) !important;
        z-index: 1;
    }
</style>
